import { c as _c } from "react/compiler-runtime";
import { type ChainId, ChainUtils } from '@morpho-org/blue-sdk';
import { useMemo } from 'react';
import type { MarketTransaction } from '@/components/MarketPage/MarketActivitySection/MarketTransactions/transactions.contract';
import { MARKET_TRANSACTION_TYPE_LABELS, MARKET_TRANSACTION_TYPE_TO_LEGACY } from '@/components/MarketPage/MarketActivitySection/MarketTransactions/config';
import { toInterfaceInputToken } from '@/helpers/interfaceToken';
import type { MarketYourTransactionsTableRow } from '../config';
export interface TransactionRows {
  transactions?: readonly MarketTransaction[];
  chainId: ChainId;
}
const useYourTableTransactionRow = t0 => {
  const $ = _c(6);
  const {
    transactions,
    chainId
  } = t0;
  let t1;
  bb0: {
    if (!transactions) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== chainId || $[2] !== transactions) {
      let t3;
      if ($[4] !== chainId) {
        t3 = tx => ({
          chainId,
          hash: tx.txHash,
          timestamp: BigInt(tx.timestamp),
          type: MARKET_TRANSACTION_TYPE_TO_LEGACY[tx.type],
          typeText: MARKET_TRANSACTION_TYPE_LABELS[tx.type],
          urlHash: ChainUtils.getExplorerTransactionUrl(chainId, tx.txHash),
          asset: toInterfaceInputToken(tx.asset, chainId),
          amount: tx.assets,
          amountUsd: tx.assetsUsd,
          user: {
            address: tx.userAddress
          }
        });
        $[4] = chainId;
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      t2 = transactions.map(t3);
      $[1] = chainId;
      $[2] = transactions;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = t2;
  }
  return t1;
};
export default useYourTableTransactionRow;